import {
  currentEnv,
  Env,
  ErrorHandling,
  executeWithRetry,
  FatalErrors,
  fetchWrapper,
} from "@classdojo/monsterverse-utils";

type OutageConfig = {
  outage: "none" | "full"; // TODO: Future "partial";
  //TODO: Future regions?: string[];
};

export class OutageError extends Error {}

export async function checkForOutage() {
  //Retrieve config
  return executeWithRetry(async () => {
    const fetchResult = await fetchWrapper(
      "outage",
      "https://clients.multiplayer.classdojo.com/launcher/outageConfig.json",
      {
        method: "GET",
        cache: "no-store",
      }
    );
    if (fetchResult.ok) {
      return (await fetchResult.json()) as OutageConfig;
    }
    throw new Error("Failed to retrieve outageConfig");
  }, 2)
    .then((outageConfig) => {
      //Check the config
      return outageConfig.outage === "full";
    })
    .catch(() => {
      //Failed to get the config after retry, assume an outage
      return true;
    });
}

export async function fatalErrorIfOutage() {
  if (currentEnv() !== Env.Prod) return;

  const outage = await checkForOutage();
  if (outage) {
    ErrorHandling.instance?.triggerFatalError(FatalErrors.Outage);
    throw new OutageError();
  }
}
